import {deepmerge} from "@mui/utils";
import type {Components} from "..";
import * as components from "./overrides";
import type {createNextTheme} from "../createNextTheme";

type Theme = ReturnType<typeof createNextTheme>;

export default function createOverrides(
    componentOptions: Partial<Components<Theme>> = {},
) {
    const allComponents = deepmerge({...componentOptions}, {...components});

    const overridesOutput = Object.entries(allComponents).reduce<Components<Theme>>(
        (acc: Components<Theme>, [muiName, overrides]) => {
            const name = muiName as keyof Components<Theme>;

            if (!overrides) return acc;

            acc[name] = {};

            type Group = keyof typeof overrides;

            Object.entries(overrides).forEach(([group, override]) => {
                const over = overrides[group as Group];
                type Override = typeof over;

                // @ts-ignore -- fix later
                acc[name][group as Group] = override as Override;
            });

            return acc;
        },
        {},
    );

    return overridesOutput;
}
